export default __webpack_public_path__ + "static/media/image7.10ec3c56.jpeg";